import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

class WinterMaintenceCompaniesTools extends Component {
  onCompaniesChangeHandler(id) {
    const { winterArea, winterAreasFilter, onSetWinterAreasFilter } = this.props;

    const filter = winterAreasFilter.map((x) => {
      if (x.winterAreaId === winterArea.id) {
        x.companyId = id;
      }

      return x;
    });

    onSetWinterAreasFilter(filter);
  }

  render() {
    const { companies, color, currentFilter } = this.props;
    return (
      <div className={styles.companiesFilterContainer}>
        <div style={{ color: color }}>Филиалы:</div>
        <div style={{ paddingLeft: "7px" }}>
          <Select
            style={{ width: "280px", height: "24px", margin: "0px", fontSize: "12px", display: "block!important" }}
            onChange={(e) => {
              this.onCompaniesChangeHandler(e.target.value);
            }}
            placeholder={"Район"}
            defaultValue={currentFilter.companiyId}
          >
            <MenuItem value={null} className={styles.MuiButtonBase_resolve}>
              Все
            </MenuItem>

            {companies.map((x) => {
              return (
                <MenuItem key={x.id} value={x.id} name={x.title} className={styles.MuiButtonBase_resolve}>
                  <div>{x.title}</div>
                </MenuItem>
              );
            })}
          </Select>
        </div>
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceCompaniesTools));
